export default "__VITE_ASSET__Cw97c3ZB__"